import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { hour_types } from 'components/ContentBox/Global/GlobalModalSingle/templates/groups/CreateTimeTable/CreateTimeTable'
import { localisationMaster } from 'Localisation/Localisation'
import { dateFormat } from 'helpers/date'
import asideModalStore from 'Stores/asideModalStore'
import DateTime from 'components/ContentBox/Global/DateTime/DateTime'
import st from './ModalWorkshopTime.module.scss'
import { superAxiosRequest } from 'axiosApi'
import cogoToast from 'cogo-toast'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import DummyCounter from 'components/ContentBox/Global/Counter/DummyCounter'
import TypeSelector from 'components/ContentBox/Global/GlobalModalSingle/templates/WorkPlain/TypeSelector'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'

export const initHours = ({ start_at, finish_at }) => {
  if (!start_at || !finish_at) return [1, 1]

  const startAt = new Date(
      `${dateFormat(new Date(), 'YYYY-mm-dd')}T${start_at}`,
    ),
    finishAt = new Date(`${dateFormat(new Date(), 'YYYY-mm-dd')}T${finish_at}`),
    diff = (finishAt - startAt) / 1000 / 60,
    hoursType = diff % 45 === 0 ? 1 : 2,
    hoursPerDay = diff / (hoursType === 1 ? 45 : 60)

  return [hoursType, hoursPerDay]
}

const ModalWorkshopTime = ({ group_id, dateFrom, dateUntil }) => {
  const { values: modalValues, updateValues, check } = asideModalStore
  const [classrooms, setClassrooms] = useState([])

  // Используем локальное состояние для hoursType и hoursPerDay
  const [initHoursType, initHoursPerDay] = initHours(modalValues)
  const [hoursType, setHoursType] = useState(initHoursType)
  const [hoursPerDay, setHoursPerDay] = useState(initHoursPerDay)

  // Функция для расчета времени
  const calculator = (val, key) => {
    let updates = {}
    const dateStr = `${dateFormat(new Date(), 'YYYY-mm-dd')}T`

    switch (key) {
      case 'hour_type':
        if (!modalValues.start_at) return

        const dateFinishAt = new Date(dateStr + modalValues.start_at)
        dateFinishAt.setMinutes(
          dateFinishAt.getMinutes() + hoursPerDay * (val === 1 ? 45 : 60),
        )

        updates = {
          finish_at: dateFormat(dateFinishAt, 'hh:ii'),
          hour_type: val,
        }
        setHoursType(val)
        break

      case 'hours_per_day':
        if (!modalValues.start_at) return

        const dateFinishAt2 = new Date(dateStr + modalValues.start_at)
        dateFinishAt2.setMinutes(
          dateFinishAt2.getMinutes() + val * (hoursType === 1 ? 45 : 60),
        )

        updates = {
          finish_at: dateFormat(dateFinishAt2, 'hh:ii'),
          hours_per_day: val,
        }
        setHoursPerDay(val)
        break

      case 'start_at':
        if (!val) return

        const dateFinishAt3 = new Date(dateStr + val)
        dateFinishAt3.setMinutes(
          dateFinishAt3.getMinutes() +
            hoursPerDay * (hoursType === 1 ? 45 : 60),
        )

        updates = {
          start_at: val,
          finish_at: dateFormat(dateFinishAt3, 'hh:ii'),
        }
        break

      case 'finish_at':
        if (!val) return

        const startAt = new Date(dateStr + val)
        startAt.setMinutes(
          startAt.getMinutes() - hoursPerDay * (hoursType === 1 ? 45 : 60),
        )

        updates = {
          start_at: dateFormat(startAt, 'hh:ii'),
          finish_at: val,
        }
        break

      case 'date_from':
        updates = { date_from: val }
        break

      case 'date_until':
        updates = { date_until: val }
        break

      default:
        break
    }

    // Обновляем значения в хранилище
    updateValues(updates)

    // Загружаем аудитории, если есть дата и время
    if (
      key === 'date_from' ||
      (key !== 'date_until' && modalValues.date_from)
    ) {
      fetchClassrooms(
        updates.date_from || modalValues.date_from,
        updates.start_at || modalValues.start_at,
        updates.finish_at || modalValues.finish_at,
      )
    }
  }

  // Загрузка доступных аудиторий
  const fetchClassrooms = async (formattedDate, startAt, finishAt) => {
    if (!formattedDate) return

    try {
      const response = await superAxiosRequest(
        {
          method: 'post',
          link: 'schedule/available_resources',
        },
        {
          group_id,
          start_at: startAt,
          finish_at: finishAt,
          dates: [formattedDate],
        },
      )
      setClassrooms(response.data.classrooms || [])
    } catch (error) {
      console.error('Error fetching classrooms:', error)
      cogoToast.error('Ошибка при загрузке аудиторий')
    }
  }

  // Обработчик изменения даты
  const handleDateChange = (date) => {
    const formattedDate = dateFormat(date, 'YYYY-mm-dd')
    calculator(formattedDate, 'date_from')
  }

  // При монтировании загружаем аудитории, если есть данные
  useEffect(() => {
    if (
      modalValues.date_from &&
      modalValues.start_at &&
      modalValues.finish_at
    ) {
      fetchClassrooms(
        modalValues.date_from,
        modalValues.start_at,
        modalValues.finish_at,
      )
    }
  }, [])

  return (
    <div className={st.fieldSet}>
      <div className={st.flex}>
        <FormField>
          <FormLabel>Hours Type:</FormLabel>
          <TypeSelector
            values={hour_types}
            like_obj={true}
            objectChangeHandler={(val) => calculator(val, 'hour_type')}
            selected={hoursType}
            name={'hour_type'}
          />
        </FormField>

        <FormField>
          <FormLabel>Hours per day:</FormLabel>
          <DummyCounter
            value={hoursPerDay}
            min={0.5}
            max={8}
            step={0.5}
            onChange={(val) => calculator(val, 'hours_per_day')}
          />
        </FormField>
      </div>

      <div className={st.flex}>
        <div className={st.flex}>
          <FormDateSelector
            placeholder='Start Date'
            label='Start Date'
            onChange={handleDateChange}
            value={modalValues.date_from || ''}
            minDate={dateFrom}
            maxDate={dateUntil}
            isRequired
            error={check('date_from')}
          />
          <FormDateSelector
            placeholder='End Date'
            label='End Date'
            onChange={(val) =>
              calculator(
                val ? dateFormat(val, 'YYYY-mm-dd') : null,
                'date_until',
              )
            }
            minDate={
              modalValues.date_from ? new Date(modalValues.date_from) : dateFrom
            }
            isRequired
            error={check('date_until')}
            maxDate={dateUntil}
            value={modalValues.date_until || ''}
          />
        </div>

        <FormField>
          <FormLabel>Start & Finish Time:</FormLabel>
          <DateTime
            placeholder='9:00'
            start_at={modalValues.start_at}
            finish_at={modalValues.finish_at}
            objectChangeHandler={(val, key) => calculator(val, key)}
          />
        </FormField>
      </div>

      <FormField>
        <FormLabel isRequired>Select Auditory:</FormLabel>
        <SelectCustom
          placeholder={localisationMaster('text_45', 'modal_templates')}
          options={classrooms.map((cr) => ({ id: cr.id, name: cr.name }))}
          valueID={modalValues.classroom}
          onChange={(o) => updateValues({ classroom: o.id })}
          error={check('classroom')}
        />
      </FormField>
    </div>
  )
}

export default observer(ModalWorkshopTime)
